module.exports = __webpack_public_path__ + "static/media/search.cb492ed6.svg";